/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Select, SelectOption } from '@americanexpress/dls-react';
import advFormStyles from '../../../styles/AdvancedFormSearch/AdvanceFormSearchStyles';

const AdvFormSelectItem = React.memo(({ formField, pageData, setPageData }) => {
  const {
    id, name, value, suggestionList,
  } = formField;

  const handleOnChange = (e, currId) => {
    const updatedPageData = { ...pageData };
    updatedPageData.formFields[currId].value = e.target.value;
    if (name === 'filterBy') {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < updatedPageData.formFields.length; i++) {
        if (updatedPageData.formFields[i].name === 'filterByValue') {
          updatedPageData.formFields[i] = { ...updatedPageData.formFields[i], value: '' };
        }
      }
    }
    setPageData(updatedPageData);
  };

  return (
    <div>
      <Select
        id={name}
        value={value}
        css={advFormStyles['.fullWidth']}
        onChange={(e) => handleOnChange(e, id)}
      >
        <SelectOption value="" />
        {suggestionList.map((e) => (
          <SelectOption key={e.id} value={e.value}>
            {e.name}
          </SelectOption>
        ))}
      </Select>
    </div>
  );
});

export default AdvFormSelectItem;
